<template>
    <div class="home">
     
      <UserContentComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import UserContentComponent from '@/components/UserContentComponent.vue'
  
  export default {
    name: 'UserView',
    components: {
        UserContentComponent
    }
  }
  </script>